import CategoryDetailPage from './CategoryDetailPage.jsx';

export {
  CategoryDetailPage
}


// WEBPACK FOOTER //
// ./pages/category-detail/index.js